const PROJECT_MODES = {
    SINGLE: 'SINGLE',
    MULTIPLAYER: 'MULTIPLAYER',
}

Object.freeze(PROJECT_MODES)

export default PROJECT_MODES
